import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './components/Layout/Navbar';
import BlogList from './components/Blog/BlogList';
import BlogDetails from './components/Blog/BlogDetails';
import BlogForm from './components/Blog/BlogForm';
import Login from './components/Auth/Login';
import Register from './components/Auth/Register';
import MyBlogs from './components/Blog/MyBlogs';
import PrivateRoute from './utils/PrivateRoute';
import { AuthProvider } from './context/AuthContext';
import { BlogProvider } from './context/BlogContext';
import HomePage from './components/Auth/HomePage';
import Footer from './components/Layout/Footer';
import UserProfile from './components/Auth/UserProfile';
import PublicProfile from './components/Auth/PublicProfile'; 

function App() {
  return (
    <Router>
      <AuthProvider>
        <BlogProvider>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <Navbar />
            <main style={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/posts" element={<BlogList />} />
                <Route path="/posts/:id" element={<BlogDetails />} />
                <Route path="/profile/:username" element={<PublicProfile />} />
                <Route path="/posts/new" element={<PrivateRoute><BlogForm /></PrivateRoute>} />
                <Route path="/profile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
                <Route path="/posts/edit/:id" element={<PrivateRoute><BlogForm /></PrivateRoute>} />
                <Route path="/profile/posts" element={<PrivateRoute><MyBlogs /></PrivateRoute>} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BlogProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
